import { clients } from '../../util/clients';

const { backendRest } = clients.direct;

const sortAnnouncementsDate = (announcementsRes) => announcementsRes.sort(
  (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
);

export const notifications = {
  namespaced: true,
  state: () => ({
    badgeAnnouncements: undefined,
    snackbarAnnouncements: [],
  }),
  mutations: {
    setBadgeAnnouncements(state, badgeAnnouncements) {
      state.badgeAnnouncements = badgeAnnouncements;
    },
    setSnackbarAnnouncements(state, snackbarAnnouncements) {
      state.snackbarAnnouncements = snackbarAnnouncements;
    },
  },
  actions: {
    async loadAnnouncements({ dispatch }, daysBack) {
      try {
        const targetDate = new Date();
        targetDate.setDate(targetDate.getDate() - daysBack);
        await dispatch('reAuth', null, { root: true });
        const response = await backendRest.get('/announcements/', {
          params: { createdAt: targetDate.toISOString() },
        });
        if (response && response.data && response.status === 200) {
          const announcementsRes = [...response.data] || [];
          return announcementsRes;
        }
        console.error('There was a problem listing announcements.');
        return [];
      } catch (e) {
        dispatch('logException', e, { root: true });
        dispatch(
          'flashError',
          `There was a problem listing announcements (${daysBack} days back).`,
          { root: true },
        );
      }
      return [];
    },
    async loadBadgeAnnouncements({ dispatch, commit }) {
      const announcementsRes = await dispatch('loadAnnouncements', 30);
      sortAnnouncementsDate(announcementsRes);
      commit('setBadgeAnnouncements', announcementsRes);
    },
    async loadSnackbarAnnouncements({ dispatch, commit }) {
      let announcementsRes = await dispatch('loadAnnouncements', 7);
      const readIDs = JSON.parse(localStorage.getItem('markReadID') || '[]');
      announcementsRes = announcementsRes.filter(
        (announcement) => !readIDs.includes(announcement._id),
      );
      sortAnnouncementsDate(announcementsRes);
      announcementsRes = announcementsRes.slice(0, 4);
      commit('setSnackbarAnnouncements', announcementsRes);
    },
  },
};

export default notifications;
